<template>
<!--<main   class="c-home u-viewport-fit-h u-overflow-h u-bg--brand-dark is-first" @touchstart="onTouchDown" @touchmove="onTouchMove" @touchend="onTouchEnd" @DOMMouseScroll="onMouseWheel" @mousewheel="onMouseWheel">-->
<main   class="c-home u-viewport-fit-h  u-bg--brand-dark is-first">


    <app-home-slide  inline-template  data-color="clear" class="c-home__section c-home__section--2 o-wrapper--valign u-flex u-flex-ai--center u-fit js-header-panel " :content="content"  :IsTolltipPopDisabled="IsTolltipPopDisabledGlob"      :headerPageSize="headerPageSize"   :activeIndex="activeIndex"   :navOffsetTop="navOffsetTop"     :indexSS="0"   :hasVideo="!1"  >
      <div class="o-wrapper--valign u-fit u-bg--white" >
        <div class="c-home__section__bar c-home__section__bar--x u-absolute u-fit-w u-bg--brand-dark u-hide@sm"></div>
        <div class="c-home__section__bar c-home__section__bar--y u-absolute u-pos-tr u-fit-h u-bg--brand-dark u-hide@sm"></div>
        <div class="c-home__section__bar c-home__section__bar--x u-absolute u-fit-w u-bg--brand-dark u-hide@sm"></div>
        <div class="c-home__section__bar c-home__section__bar--y u-absolute u-pos-bl u-fit-h u-bg--brand-dark u-hide@sm"></div>
         <span class="c-home__section__chapter t-text--xxs t-text--base-home u-absolute u-color--alpha-white u-hide@sm">{{'0'+(indexSS)}}</span>
         <div class="o-wrapper--panel u-zindex--1 u-fit u-bg--black">
           <img src="../../assets/medias/images/PrivInvestSupperYacht-background.jpg" class="c-home__section__poster c-home__section__poster--2 o-wrapper--panel u-zindex--2 u-fit u-object-fit-cover">
           <div class="c-home__section__poster__filter u-absolute u-pos-tl u-zindex--1 u-fit" style="background-color: #ffffff"> </div>
         </div>
         <div class="u-absolute u-pos-tl  u-marg-t-mdvh  u-marg-x-w1of4  u-marg-t-xl@sm  u-zindex--1 u-marg-l-w1of24 u-marg-l-w3of8@xsm ">
           <div class="u-w2of2 u-fit-w@md">

               <div class="u-flex t-text--sm t-text--base-home c-Home--title-lheigt  u-marg-t-xxl">
                   <!--  <span class="c-number-offset--home t-text--xl--Light   c-home-u-color--gray u-absolute u-pos-bl u-marg-b-xs3@sm">{{'0'+(indexSS)}} supper Yacht title</span>
                    <span class="c-home__section__coverage__subsidtitleText  u-color-white t-text--base-home">{{content.second_slide_subtitle}}</span>-->
                   </div>
               </div>
         </div>

          <div class="c-home__section__fade  u-w2of2   u-w9of12@lg u-fit-w@sm u-zindex--1 ">
            <div class="u-marg-l-0@sm   u-fit-w@sm   u-pad-t-ultra2@sm    u-pad-t-xxl  u-zindex--1 " style="max-height: 750px;">
                  <carousel  :perPageCustom="[[320,14],[500,14],  [720, 1.3],[1024, 1.4],[1200, 2.3],[1500, 2.3]]"  :navigationEnabled="true"  :paginationEnabled="true" :paginationActiveColor="'#ffffff'"  :paginationColor="'#6e6e6e'"  :paginationSize="14" >
                      <slide v-for="(post,indexkey)  in content.posts_offer['1']" :key="indexkey" @slideclick="onOpenPopinCar(post,indexkey)">
                        <div class="containercarousel_Image u-marg-t-md@sm">
                          <img :src="post.images[0].sizes.large"  style="width:100%;min-width:300px;">
                          <div  class="blockdownInfo u-marg-t-xs@sm" :style="'padding-left:'+post.Paddleft+'px'">
                            <div class="t-text--ultra name u-color--white"  v-html="post.title"></div>
                          </div>
                          <div  class="blockdownInfo2" >
                            <div class="t-text--md  name u-color--white">{{post.first_paragraph_shorted}}</div>
                          </div>
                        </div>

                      </slide>
                  </carousel>
            </div>
          </div>
          <div class="u-relative u-inline-block u-valign-top u-fit-h  u-overflow-h u-w3of12 u-hide@sm">

            </div>
            <div class="c-home__line-aside u-absolute u-bg--white" :style="stylesHeight1"></div>
            <div class="c-home__line-aside c-home__line-aside--bottom u-absolute u-bg--white" :style="stylesHeight1"></div>
            <app-car-details   :content="popinContent" :key="componentKey"  :title="popinTitle" :index="0"  :isActive="isPopinActive"  ></app-car-details>
            </div>
     </app-home-slide>
</main>
</template>

<script>
import appHomeSlide from '../app-home-slide/index.vue'

export default {
    props: {
      debug: {
          type: Boolean,
          default: !1
      },
        adminContent: {
            type: Object,
            default: function() {}
        },
        globalContent: {
            type: Object,
            default: function() {}
        },
        headerPageSize: {
            type: Array,
            default: function() {}
        }
        ,
        isPopinActive:
        {
          type:Boolean,
          default: !1
        }
    },
    components: {
        'app-home-slide':appHomeSlide

},
    mixins: [],
    data: function() {
        return {
            activeIndex: 0,
            activeRollOverIndex: 0,
            navHeight: 0,
            navOffsetTop: 0,
            IsTolltipPopDisabledGlob:!0
        }
    },
    computed:
    {

        content: function() {
            return this.adminContent.en.pages.home
        },
        myStylesNavHeight() {
            return {
                height: this.navHeight+'px',
                width:'70px'
            }
        },
        myStylesTransform1() {
            return {
                transform: 'translateY('+100*this.activeRollOverIndex+') translateZ(0) ',

            }
        }
    },
    created: function() {

           this.PIXEL_STEP = 10,
            this.LINE_HEIGHT = 40,
            this.PAGE_HEIGHT = 800,
            this.NBSLIDE = 8,
            this._isWheeling = !1,
            this._isPointerDown = !1,
            this._pointerY = 0,
            this._pointerStartY = 0,
            this.eventHub.$on("resize", this.onResize);


    },
    destroyed: function()
    {
        this.eventHub.$off("resize", this.onResize)

    },
    mounted: function()
    {

            this.eventHub.$emit("page:ready"),
            this.$nav = this.$el.querySelector(".js-nav"),
            this.onResize();

            if(this.$route.query.section)
            {
                this.onDotClick(parseInt(this.$route.query.section));
            }

    },
    methods:
    {

        _getFooter: function()
        {
            return this.adminContent.en["theme-general-settings"].footer_copyright_label.replace("<year>", (new Date).getFullYear())
        },
        GoTop: function(t)
         {
         },
        onMouseWheel: function(t)
         {
          // console.log("this.isPopinActive" +this.isPopinActive);
           if(!this.isPopinActive)
           {
            var e = this;
            t.preventDefault(),
             t.stopPropagation(),
             clearTimeout(this.wheelTimer),
              this.wheelTimer = setTimeout(function() {  e._isWheeling = !1}, 500);

            if (Math.abs(-this.normalizeWheel(t).pixelY) < 10 && (clearTimeout(this.wheelTimer), this._isWheeling = !1), !(this._isWheeling || Math.abs(-this.normalizeWheel(t).pixelY) < 10 || Date.now() - this._lastWheelTime < 1e3))
            {

                this._lastWheelTime = Date.now(),
                 this._wheelEndTimer = setTimeout(function() {clearTimeout(e.wheelTimer), e._isWheeling = !1  }, 1e3),
                 this._isWheeling = !0,
                 this._isScrollFromWheel = !0;
                var n = this.normalizeWheel(t),
                    r = -n.pixelY;
                    //console.log("this is:" +r);
                    if(this.activeIndex<8&&r < 0)
                    {
                      this.onNextSlide()
                    }
                    if(this.activeIndex<=8&&r > 0)
                    {
                      this.onPrevSlide()
                    }
                    //r < 0 ? this.onNextSlide() : r > 0 && this.onPrevSlide()
            }
            }
        },
        onResize: function()
        {
          this.debug&&console.log('On resize start method inside app-page-home');
          //  this.navHeight = this.$nav.offsetHeight,
          //  this.navOffsetTop = this.$nav.offsetTop - .5 * this.navHeight
            this.debug&&console.log('On resize start method inside app-page-home End');
        },
        onPrevSlide: function()
        {
            this.activeIndex > 0 && (this.activeIndex -= 1, this.onChangeSlide())
        },
        onNextSlide: function()
        {
            this.activeIndex < this.NBSLIDE - 1 && (this.activeIndex += 1, this.onChangeSlide())
        },
        onDotClick: function(t)
        {

            this.activeIndex = t,

            this.onChangeSlide()
        },
        onDotOver: function(t)
        {
            this.activeRollOverIndex = t
        },
        onDotOut: function()
        {
            this.activeRollOverIndex = this.activeIndex
        },
        onMenuOver: function()
        {

            0 !== this.activeIndex && this.$el.classList.add("is-menu-hover"),
            this.$GetAllSignLogo = document.querySelectorAll(".c-home__section__logo"),
            this.$GetAllSignLogo.forEach(function(navLogoSign) {
                navLogoSign.classList.add("u-hide")
                                                                                            })
        },
        onMenuOut: function()
        {
            this.$el.classList.remove("is-menu-hover"),
            this.$GetAllSignLogo = document.querySelectorAll(".c-home__section__logo"),
            this.$GetAllSignLogo.forEach(function(navLogoSign) {
                navLogoSign.classList.remove("u-hide")
                                                                                            })

        },
        onChangeSlide: function()
        {

          if(this.activeIndex===8)
          {
          this.IsTolltipPopDisabledGlob=!1

          }
          else {
            this.IsTolltipPopDisabledGlob=!0
          }
            this.eventHub.$emit("close:popin"),

            8 === this.activeIndex ? this.$el.classList.add("is-last") : this.$el.classList.remove("is-last"),
            this.activeRollOverIndex = this.activeIndex,
            this.eventHub.$emit("change:slide", this.activeRollOverIndex),
                0 === this.activeIndex ? (this.$el.classList.add("is-first"),
                    this.eventHub.$emit("show:header")) : (this.$el.classList.remove("is-first"),
                    this.eventHub.$emit("hide:header"))

        },
        onTouchDown: function(t)
        {
          if(!this.isPopinActive)
          {
            this._isPointerDown = !0,
            this._pointerStartY = t.touches[0].clientY,
             this._pointerY = this._pointerStartY
           }
        },
        onTouchMove: function(t)
        {
          if(!this.isPopinActive)
          {
            this._isPointerDown && (t.preventDefault(),
             this._pointerY = t.touches[0].clientY)
           }
        },
        onTouchEnd: function(t)
        {
          if(!this.isPopinActive)
          {
              if(this.activeIndex<8)
              {
                  this._isPointerDown &&
                  (this._isPointerDown = !1,  Math.abs(this._pointerStartY - this._pointerY)
                  > 10 && (this._pointerY > this._pointerStartY ? this.onPrevSlide() : this.onNextSlide()))
            }
            if(this.activeIndex==8)
            {
              this._isPointerDown &&
              (this._isPointerDown = !1,  Math.abs(this._pointerStartY - this._pointerY)
              > 10 && (this._pointerY > this._pointerStartY ? this.onPrevSlide() : ''))
            }
          }
        },
        normalizeWheel: function(t)
        {
          //console.log(t);
            return this._sX = 0,
             this._sY = 0,
              this._pX = 0,
              this._pY = 0,
              "detail" in t && (this._sY = t.detail),
               "wheelDelta" in t && (this._sY = -t.wheelDelta / 120),
               "wheelDeltaY" in t && (this._sY = -t.wheelDeltaY / 120),
               "wheelDeltaX" in t && (this._sX = -t.wheelDeltaX / 120),
                "axis" in t && t.axis === t.HORIZONTAL_AXIS && (this._sX = this._sY, this._sY = 0),
                this._pX = this._sX * this.PIXEL_STEP,
                this._pY = this._sY * this.PIXEL_STEP,
                "deltaY" in t && (this._pY = t.deltaY),
                "deltaX" in t && (this._pX = t.deltaX),
                (this._pX || this._pY) && t.deltaMode && (1 == t.deltaMode ? (this._pX *= this.LINE_HEIGHT, this._pY *= this.LINE_HEIGHT) : (this._pX *= this.PAGE_HEIGHT, this._pY *= this.PAGE_HEIGHT)),
                this._pX && !this._sX && (this._sX = this._pX < 1 ? -1 : 1),
                 this._pY && !this._sY && (this._sY = this._pY < 1 ? -1 : 1),
                 {
                spinX: this._sX,
                spinY: this._sY,
                pixelX: this._pX,
                pixelY: this._pY
            }
        }
    }
}

</script>
<style  scoped>
.VueCarousel-inner {
    display: flex;
    flex-direction: column;
    backface-visibility: hidden;
}

@media (max-width:1800px)
{
  .containercarousel_Image{
   padding-left: 100px;
  }
}
@media (max-width:1023px) {
  .containercarousel_Image{
   padding-left: 100px;
  }
}
@media (max-width:1599px){

}

@media (max-width:1199px){

}

@media (max-width:767px){

}
@media (max-width:579px) {


}
@media (max-width:440px)
{
  .containercarousel_Image{

  }
}
@media (max-width:374px){

}
</style>
